import { writable } from "svelte/store";
export const isWidgetOpen = writable(false);
export const messageList = writable([]);
export const fetchMessageLoading = writable(true);
export const sendMessageLoading = writable(false);
export const apiTokenValue = writable();
export const botInfo = writable();
